export const isServer = () => process.server;
